import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6647ac0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-tt" }
const _hoisted_2 = { class: "nge-tt-top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Tutorial times", -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-tt-sub" }, "How long players spend on each box. A box is counted up to 10 minutes.", -1 /* HOISTED */))
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "nge-tt-err"
}
const _hoisted_7 = {
  key: 1,
  class: "nge-tt-how"
}
const _hoisted_8 = {
  key: 2,
  class: "nge-tt-picks"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 3,
  class: "nge-tt-table"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Box"),
    /*#__PURE__*/_createElementVNode("th", null, "Title"),
    /*#__PURE__*/_createElementVNode("th", null, "Seen"),
    /*#__PURE__*/_createElementVNode("th", null, "Players"),
    /*#__PURE__*/_createElementVNode("th", null, "Median"),
    /*#__PURE__*/_createElementVNode("th", null, "Slowest 10%"),
    /*#__PURE__*/_createElementVNode("th", null, "Help me"),
    /*#__PURE__*/_createElementVNode("th", null, "Left here")
  ])
], -1 /* HOISTED */))
const _hoisted_12 = { class: "nge-tt-title" }
const _hoisted_13 = { class: "nge-tt-median" }
const _hoisted_14 = {
  key: 4,
  class: "nge-tt-h3"
}
const _hoisted_15 = {
  key: 5,
  class: "nge-tt-runs"
}
const _hoisted_16 = { class: "nge-tt-sub" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("button", {
        class: "nge-hud-btn nge-hud-btn--sm nge-tt-refresh",
        disabled: $setup.loading,
        onClick: $setup.load
      }, _toDisplayString($setup.loading ? 'Loading' : 'Refresh'), 9 /* TEXT, PROPS */, _hoisted_5)
    ]),
    ($setup.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($setup.error), 1 /* TEXT */))
      : (!$setup.loading && !$setup.stats.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, "No times yet. They arrive as players go through tutorials."))
        : _createCommentVNode("v-if", true),
    ($setup.tutorials.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tutorials, (t) => {
            return (_openBlock(), _createElementBlock("button", {
              key: t,
              class: _normalizeClass(["nge-tt-pick", { 'nge-tt-pick--on': $setup.pick === t }]),
              onClick: $event => ($setup.pick = t)
            }, _toDisplayString($setup.name(t)), 11 /* TEXT, CLASS, PROPS */, _hoisted_9))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.rows.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.rows, (r) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: r.step
              }, [
                _createElementVNode("td", null, _toDisplayString(r.step + 1), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_12, _toDisplayString(r.last_box || ''), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(r.n), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(r.players), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_13, [
                  _createElementVNode("span", {
                    class: "nge-tt-bar",
                    style: _normalizeStyle({ width: (Number(r.median_s) / $setup.maxMedian * 100) + '%' })
                  }, null, 4 /* STYLE */),
                  _createElementVNode("span", null, _toDisplayString($setup.secs(r.median_s)), 1 /* TEXT */)
                ]),
                _createElementVNode("td", null, _toDisplayString($setup.secs(r.p90_s)), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString($setup.pct(r.help_rate)), 1 /* TEXT */),
                _createElementVNode("td", {
                  class: _normalizeClass({ 'nge-tt-hot': r.closes > 0 })
                }, _toDisplayString(r.closes), 3 /* TEXT, CLASS */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.runs.length)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_14, "Latest runs"))
      : _createCommentVNode("v-if", true),
    ($setup.runs.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.runs, (r, i) => {
            return (_openBlock(), _createElementBlock("li", { key: i }, [
              _createElementVNode("b", null, _toDisplayString(r.who), 1 /* TEXT */),
              _createTextVNode(),
              _createElementVNode("span", _hoisted_16, _toDisplayString(r.when), 1 /* TEXT */),
              _createTextVNode(" · " + _toDisplayString(r.boxes) + " boxes in " + _toDisplayString($setup.secs(r.total)) + " · " + _toDisplayString(r.ended) + " ", 1 /* TEXT */),
              (r.help)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" · Help me " + _toDisplayString(r.help) + "×", 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              _createTextVNode(" · slowest: box " + _toDisplayString(r.slowest.step + 1) + " (" + _toDisplayString($setup.secs(r.slowest.seconds)) + ") ", 1 /* TEXT */)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}